import { render } from "./InlineForm.vue?vue&type=template&id=46ed0ab8"
import script from "./InlineForm.vue?vue&type=script&lang=ts"
export * from "./InlineForm.vue?vue&type=script&lang=ts"
script.render = render

export default script